'use es6';

import { createSelector } from '@reduxjs/toolkit';
import { getFileUploadListForCurrentThreadId } from '../../file-uploads/selectors/getFileUploadListForCurrentThreadId';
import { hasUnansweredQuickReplyMessage as hasUnansweredQuickReplyMessageSelector } from '../../selectors/chatSelectors';
import { getAllowUserInput } from '../../thread-histories/selectors/getAllowUserInput';
import { getShouldDisableAttachments } from '../../widget-ui/selectors/getShouldDisableAttachments';
import { getCurrentThreadId } from '../../thread-history/selectors/getCurrentThreadId';
import { STUBBED_THREAD_ID } from '../../threads/constants/stubbedThreadId';
export const canUploadAttachments = createSelector([getAllowUserInput, getFileUploadListForCurrentThreadId, hasUnansweredQuickReplyMessageSelector, getShouldDisableAttachments, getCurrentThreadId], (allowUserInput, uploadList, hasUnansweredQuickReplyMessage, shouldHideAttachments, currentThreadId) => {
  if (currentThreadId === STUBBED_THREAD_ID || !allowUserInput && hasUnansweredQuickReplyMessage || shouldHideAttachments) {
    return false;
  } else if (!uploadList) {
    return true;
  }
  return !uploadList.size;
});